import { InfoListProps } from './InfoList.types'
import { InfoListRoot } from './InfoList.styles'
import React from 'react'
import Typography from '../typography/Typography'

const InfoList = ({ items, ...props }: InfoListProps) => {
    return (
        <InfoListRoot {...props}>
            {items.map((item, index) => {
                return (
                    <li key={index}>
                        <Typography className='text-main-bodyRegular' as='strong' size='large' type='semibold'>
                            {item.key}:
                        </Typography>
                        <Typography className='text-main-bodyRegular' size='large'>
                            {item.value}
                        </Typography>
                    </li>
                )
            })}
        </InfoListRoot>
    )
}

export default InfoList
